var symphony = symphony || {};

;
(function () {

	symphony.getHelpHeader = function () {

		bridgesWrapper.fillZip();
		bridgesWrapper.fillName();

		var getHelpFirstName = $('#firstName');
		var getHelpContainer = $('.getHelp-steps');
		var selectedCategories = [];

		var vars = {
			zip: window.localStorage && localStorage.getItem('zip') != null ? JSON.parse(localStorage.getItem('zip')) : '',
			name: window.localStorage && localStorage.getItem('firstName') != null ? JSON.parse(localStorage.getItem('firstName')) : '',
			cats: window.localStorage && localStorage.getItem('selectedCategories') != null ? JSON.parse(localStorage.getItem('selectedCategories')) : ''
		};

		$('.js-getHelp').on('click', function (e) {

			if (window.innerWidth > 991) {
				e.preventDefault();
				if (!bridgesWrapper.config.headerContainer.hasClass('slick-initialized')) {
					bridgesWrapper.config.headerContainer.slick({
						arrows: false,
						adaptiveHeight: true,
						cssEase: 'ease-in'
					});
				}

				if (!$('body').hasClass('kroc-theme') && !$('body').hasClass('header-isSticky')) {
					$('body').addClass('header-isSticky');
				}

				if (symphony.config.utilities.expandingHeader.hasClass('isExpanded')) {
					symphony.config.utilities.expandingHeader.removeClass('isExpanded');
				} else {
					$('.getHelp').addClass('isExpanded');
				}
			} else {
				if (siteUrlAlias != thqUrlAlias) {
					window.open(getHelpUrl + '#results');
				} else {
					location.assign(getHelpUrl + '#results');
				}
			}


		});

		$('.getHelp-steps').find('#firstName').on('keyup keydown', function () {
			vars.name = $(this).val();
			if (window.localStorage) {
				localStorage.setItem('firstName', JSON.stringify($(this).val()));
			}
			//bridgesWrapper.fillName();
		});

		$('.getHelp-steps').find('#zip').on('keyup keydown', function () {
			vars.zip = $(this).val();
			if (window.localStorage) {
				localStorage.setItem('zip', JSON.stringify($(this).val()));
			}
			//bridgesWrapper.fillZip();
		});

		$('.js-stepForward').on('click', function (e) {
			e.preventDefault();
			getHelpContainer.slick('slickNext');
			$('.getHelp-form.inHeader .getHelp-categories').on('change', function () {
				selectedCategories = $('.getHelp-form.inHeader .getHelp-categories').find('input:checked').data('type');
				vars.cats = selectedCategories;
				if (window.localStorage) {
					localStorage.setItem('selectedCategories', JSON.stringify(selectedCategories));
				}
			});
			$('.bridges-Submit').on('click', function (e) {
				if (siteUrlAlias != thqUrlAlias) {
					window.open(getHelpUrl + '?zip=' + vars.zip + '&name=' + vars.name + '&cats=' + vars.cats + '#results');
				} else {
					location.assign(getHelpUrl + '?zip=' + vars.zip + '&name=' + vars.name + '&cats=' + vars.cats + '#results');
				}
			});
		});

		$('.js-stepBack').on('click', function (e) {
			e.preventDefault();
			getHelpContainer.slick('slickPrev');
		});


		function getResults(name, zip, categories) {

			gdosWrapper.getLatLong(zip).done(function (data) {

				if (data.longitude !== null && data.latitude !== null) {
					gdosWrapper.config.latLong = [data.latitude, data.longitude];
					var url = bridgesWrapper.config.api + gdosWrapper.config.latLong[0] + '/' + gdosWrapper.config.latLong[1];
					bridgesWrapper.config.api = url + '/100?';
				} else {
					console.log('error message');
				}

				bridgesWrapper.getJSON(bridgesWrapper.constructUrl()).done(function (data) {
					if (data && data.serviceProviders.length > 0) {

						bridgesWrapper.storeResults(data);
						bridgesWrapper.displayResults();
						bridgesWrapper.updateMap();

					} else if (data && data.serviceProviders.length === 0) {
						// If api success, but there are no results, get the default data for testing
						$.get('https://api.usawest.org/bridges/api/v1/ServiceProviders/32/-110/100', function (data) {
							bridgesWrapper.storeResults(data);
							bridgesWrapper.displayResults();
							bridgesWrapper.updateMap();
						});

					} else {

						bridgesWrapper.config.resultsContainer.empty().append('No results');

					}

					if (siteUrlAlias != thqUrlAlias) {
						window.open(getHelpUrl + '?zip=' + vars.zip + '&name=' + vars.name + '&cats=' + vars.cats + '#results');
					} else {
						location.assign(getHelpUrl + '?zip=' + vars.zip + '&name=' + vars.name + '&cats=' + vars.cats + '#results');
					}
				});

			});


		}

	};


})();
